import React from 'react';
import { useTranslation } from 'react-i18next';
import BasePageView from '../sharedComponents/BasePageView/BasePageView';

export default function AttendeesView() {
  const { t } = useTranslation();

  return (
    <BasePageView title={t('event.attendees')} informaPageId="attendees" />
  );
}
